import React from "react";

export default function StateGuard({ loading, error, empty, emptyMessage, children }) {
  if (loading) return <div className="oad-state-msg">Chargement…</div>;
  if (error) return <div className="oad-state-msg oad-error">{error}</div>;
  if (empty)
    return (
      <div className="oad-state-msg">
        {emptyMessage || "Pas de données pour cette sélection."}
      </div>
    );
  return children;
}
